"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HourlyBreakdownFeature = void 0;
var react_1 = __importStar(require("react"));
var HourlyBreakdown_1 = require("../../views/HourlyBreakdown");
var hooks_1 = require("../../hooks");
var atoz_shiftapp_utilities_1 = require("@amzn/atoz-shiftapp-utilities");
var atoz_dashboard_taa_components_1 = require("@amzn/atoz-dashboard-taa-components");
var HourlyBreakdownFeature = function (props) {
    var features = (0, atoz_shiftapp_utilities_1.useAssociateContext)().features;
    if (features.useTaaDashboardComponents) {
        return (react_1.default.createElement(atoz_dashboard_taa_components_1.HourlyBreakdownFeature, __assign({}, props, { featureGates: {
                canDeleteDuplicatePunch: props.canDeleteDuplicatePunch,
                isATPlusTemporalRoutingEnabled: features.isATPlusTemporalRoutingEnabled
            } })));
    }
    return react_1.default.createElement(HourlyBreakdownFeatureInternal, __assign({}, props));
};
exports.HourlyBreakdownFeature = HourlyBreakdownFeature;
var HourlyBreakdownFeatureInternal = function (_a) {
    var employeeId = _a.employeeId, selectedDate = _a.selectedDate, timeRange = _a.timeRange, canDeleteDuplicatePunch = _a.canDeleteDuplicatePunch;
    var data = (0, hooks_1.usePunches)({
        employeeId: employeeId,
        timeRange: timeRange,
        isEligibilityEnabled: canDeleteDuplicatePunch
    }).data;
    var timeSegmentsByDate = (0, react_1.useMemo)(function () {
        var _a;
        var map = new Map();
        (_a = data === null || data === void 0 ? void 0 : data.timeSegmentDailyAggregation) === null || _a === void 0 ? void 0 : _a.forEach(function (_a) {
            var _b;
            var date = _a.date, amountInMinutes = _a.amountInMinutes, timeSegmentTypeId = _a.timeSegmentTypeId;
            var hourlyBreakdownEntry = map.get(date) || {};
            map.set(date, __assign(__assign({}, hourlyBreakdownEntry), (_b = {}, _b[timeSegmentTypeId] = amountInMinutes, _b)));
        });
        return map;
    }, [data === null || data === void 0 ? void 0 : data.timeSegmentDailyAggregation]);
    var dateKey = selectedDate.toFormat('M/dd/yyyy');
    return (react_1.default.createElement(HourlyBreakdown_1.HourlyBreakdown, { hourlyBreakdownList: timeSegmentsByDate.get(dateKey) }));
};
